module.exports = __webpack_public_path__ + "media/styles/images/png/arrow-right-white-tall-0feabd0a570e3d4c17a63b7a5d1bc6d6.png";